import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const AvgIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} width="25px" height="25px" viewBox="0 0 18.0 18.0">
        <defs>
            <clipPath id="i0">
                <path d="M1,0 L1,6 L0,6 L0,1 C-6.28042769e-17,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 Z" />
            </clipPath>
            <clipPath id="i1">
                <path d="M3,0 C3.51283584,-9.42064153e-17 3.93550716,0.38604019 3.99327227,0.883378875 L4,1 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L3,0 Z" />
            </clipPath>
            <clipPath id="i2">
                <path d="M4,0 L4,1 L0,1 L0,0 L4,0 Z" />
            </clipPath>
            <clipPath id="i3">
                <path d="M0,0 C0.55228475,-1.01453063e-16 1,0.44771525 1,1 L1,6 L0,6 L0,0 Z" />
            </clipPath>
            <clipPath id="i4">
                <path d="M1,0 L1,4.5 L0,4.5 L0,0 L1,0 Z" />
            </clipPath>
            <clipPath id="i5">
                <path d="M1,0 L1,2.12132034 L0,2.12132034 L0,0 L1,0 Z" />
            </clipPath>
            <clipPath id="i6">
                <path d="M1,0 L1,2.12132034 L0,2.12132034 L0,0 L1,0 Z" />
            </clipPath>
            <clipPath id="i7">
                <path d="M1,0 L1,1 L0,1 L0,0 L1,0 Z" />
            </clipPath>
            <clipPath id="i8">
                <path d="M1,0 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 L0,1 C-6.28042769e-17,0.487164161 0.38604019,0.0644928393 0.883378875,0.00672773133 L1,0 Z" />
            </clipPath>
            <clipPath id="i9">
                <path d="M4,0 C4,0.55228475 3.55228475,1 3,1 L1,1 C0.44771525,1 6.76353751e-17,0.55228475 0,0 L4,0 Z" />
            </clipPath>
            <clipPath id="i10">
                <path d="M2,0 L2,1 L0,1 L0,0 L2,0 Z" />
            </clipPath>
            <clipPath id="i11">
                <path d="M1,0 L1,2 C1,2.51283584 0.61395981,2.93550716 0.116621125,2.99327227 L0,3 L0,0 L1,0 Z" />
            </clipPath>
            <clipPath id="i12">
                <path d="M0,0 C0.55228475,-1.01453063e-16 1,0.44771525 1,1 L1,2 L0,2 L0,0 Z" />
            </clipPath>
        </defs>
        <g transform="translate(2.0 6.0)">
            <g clipPath="url(#i0)">
                <polygon
                    points="0,0 1,0 1,6 0,6 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
            <g clipPath="url(#i1)">
                <polygon
                    points="0,0 4,0 4,1 0,1 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
            <g transform="translate(0.0 3.0)">
                <g clipPath="url(#i2)">
                    <polygon
                        points="0,0 4,0 4,1 0,1 0,0"
                        stroke="none"
                        fill="#000000"
                    />
                </g>
            </g>
            <g transform="translate(3.0 0.0)">
                <g clipPath="url(#i3)">
                    <polygon
                        points="0,0 1,0 1,6 0,6 0,0"
                        stroke="none"
                        fill="#000000"
                    />
                </g>
            </g>
        </g>
        <g transform="translate(7.0 6.0)">
            <g clipPath="url(#i4)">
                <polygon
                    points="0,0 1,0 1,4.5 0,4.5 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(6.999999999997901 10.500000000001082) rotate(-44.99999999999999)">
            <g clipPath="url(#i5)">
                <polygon
                    points="-2.84217094e-14,0 1,0 1,2.12132034 -2.84217094e-14,2.12132034 -2.84217094e-14,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(10.292893218813573 9.7928932188128) rotate(45.00000000000001)">
            <g clipPath="url(#i6)">
                <polygon
                    points="-2.84217094e-14,2.84217094e-14 1,2.84217094e-14 1,2.12132034 -2.84217094e-14,2.12132034 -2.84217094e-14,2.84217094e-14"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(12.0 6.0)">
            <g clipPath="url(#i1)">
                <polygon
                    points="0,0 4,0 4,1 0,1 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(8.5 11.0)">
            <g clipPath="url(#i7)">
                <polygon
                    points="0,0 1,0 1,1 0,1 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(10.0 6.0)">
            <g clipPath="url(#i4)">
                <polygon
                    points="0,0 1,0 1,4.5 0,4.5 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(12.0 6.0)">
            <g clipPath="url(#i8)">
                <polygon
                    points="0,0 1,0 1,6 0,6 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(12.0 11.0)">
            <g clipPath="url(#i9)">
                <polygon
                    points="0,0 4,0 4,1 0,1 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(14.0 9.0)">
            <g clipPath="url(#i10)">
                <polygon
                    points="0,0 2,0 2,1 0,1 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(15.0 9.0)">
            <g clipPath="url(#i11)">
                <polygon
                    points="0,0 1,0 1,3 0,3 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
        <g transform="translate(15.0 6.0)">
            <g clipPath="url(#i12)">
                <polygon
                    points="0,0 1,0 1,2 0,2 0,0"
                    stroke="none"
                    fill="#000000"
                />
            </g>
        </g>
    </SvgIcon>
);

export default AvgIcon;
